// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x7FP","newExpiryDate":"styles_newExpiryDate__cO6fG","footer":"styles_footer__2Pef9"};